import { Form } from "@/atoms"
import { ActionButtonsFooter } from "@/pages/SettingsPage/components/molecules/ActionButtonsFooter"
import { TicketingNotificationFields } from "./TicketingNotificationFields"
import { fromGroupedValues, toGroupedValues } from "./ticketingSettingsAdapter"

import styles from "./TicketingNotificationForm.module.scss"

import type { TicketingNotificationFormProps } from "./TicketingNotificationForm.types"

export const TicketingNotificationForm = (
  props: TicketingNotificationFormProps
) => {
  const {
    id,
    name,
    settings,
    keyPrefix,
    vendorName,
    form,
    isDirty,
    isPending,
    isDisabled,
    onFieldsChange,
    onUpdate,
    onReset,
    footerStart
  } = props

  return (
    <>
      <Form
        form={form}
        id={id}
        initialValues={toGroupedValues(settings)}
        disabled={isDisabled}
        onFieldsChange={onFieldsChange}
        onFinish={(values) => {
          onUpdate(
            { data: { notificationSettings: fromGroupedValues(values) } },
            { name }
          )
        }}
      >
        <TicketingNotificationFields
          keyPrefix={keyPrefix}
          vendorName={vendorName}
          undismissed
          className={styles.description}
        />
      </Form>

      <div className={styles.footer}>
        {footerStart && <div className={styles.footerStart}>{footerStart}</div>}
        <ActionButtonsFooter
          onOk={() => form.submit()}
          onCancel={onReset}
          okLoading={isPending}
          okDisabled={!isDirty || isDisabled}
          cancelDisabled={!isDirty || isDisabled}
        />
      </div>
    </>
  )
}
